/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import {DashboardLoadedActionFail, DashboardLoadedActionInProgress, DashboardLoadedActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';


/**
 * @function DashboardLoadedActionCreator
 * @param {}
 * @return {Promise<any>}  Promise
 */
export function DashboardLoadedActionCreator(): (dispatch: Dispatch<any>, {}) =>
    Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(DashboardLoadedActionInProgress());

    try {
      const data = ' dashboard!!! ';
      await dispatch(DashboardLoadedActionSuccess(data));

    } catch (error) {
      dispatch(DashboardLoadedActionFail(error));
    }
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/supervision/dashboard/home/index.ts